'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = (0, _immutable.Map)({}); // @low
//# sourceMappingURL=defaults.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/redux-config-provider/dist/main/defaults.js
// module id = 266
// module chunks = 0